import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: PolicyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-147">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-148">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-brown-900/60 backdrop-blur-sm" onClick={onClose} data-id="element-149" />

          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-cream-50 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden border border-cream-200" data-id="element-150">
            <div className="sticky top-0 bg-cream-50 border-b border-cream-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-151">
              <h2 className="text-xl font-serif font-bold text-brown-900" data-id="element-152">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-cream-200 transition-colors text-brown-600 hover:text-brown-900" aria-label="Close" data-id="element-153">
                <X className="w-5 h-5" data-id="element-154" />
              </button>
            </div>

            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-brown-800 leading-relaxed text-sm space-y-4" data-id="element-155">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}